import { ACT_SLUG, DAT_SLUG, LSAT_SLUG, MCAT_SLUG, SAT_SLUG } from 'my-core/course-utils';

import {
  faBalanceScale,
  faExclamation,
  faGraduationCap,
  faInfo,
  faLightbulb,
  faMedkit,
  faPencil,
  faStickyNote,
  faTooth,
} from '@fortawesome/pro-solid-svg-icons';

export default {
  WIZE_CONCEPT: {
    icon: faLightbulb,
    title: 'Wize Concept',
    color: 'primary',
  },
  WIZE_TIP: {
    icon: faInfo,
    title: 'Wize Tip',
    color: 'green',
  },
  EXAM_TIP: {
    icon: faStickyNote,
    title: 'Exam Tip',
    color: 'cyan',
  },
  WARNING: {
    icon: faExclamation,
    title: 'Watch Out!',
    color: 'orange',
  },

  MCAT_TIP: {
    icon: faMedkit,
    title: 'MCAT Tip',
    color: 'secondary',
  },
  LSAT_TIP: {
    icon: faBalanceScale,
    title: 'LSAT Tip',
    color: 'secondary',
  },
  WRITE_IT_DOWN: {
    icon: faPencil,
    title: 'Write it Down',
    color: 'purple',
  },
  COURSE_TIP: {
    icon: faLightbulb,
    title: 'Course Tip',
    color: 'primary',
    contexts: {
      [MCAT_SLUG]: { icon: faMedkit, title: 'MCAT Tip', color: 'secondary' },
      [LSAT_SLUG]: { icon: faBalanceScale, title: 'LSAT Tip', color: 'secondary' },
      [DAT_SLUG]: { icon: faTooth, title: 'DAT Tip', color: 'cyan' },
      [SAT_SLUG]: { icon: faGraduationCap, title: 'SAT Tip', color: 'primary' },
      [ACT_SLUG]: { icon: faGraduationCap, title: 'ACT Tip', color: 'primary' },
    },
  },
};
